import { Controller } from "@hotwired/stimulus"

// Alternador de usuários (ferramenta de dev): abre/fecha o painel e filtra a
// lista por nome ou papel. Sem chamadas ao servidor — a lista já vem renderizada.
export default class extends Controller {
  static targets = ["panel", "search", "item", "group"]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    if (!this.panelTarget.classList.contains("hidden")) this.searchTarget.focus()
  }

  filter() {
    const term = this.searchTarget.value.trim().toLowerCase()

    this.itemTargets.forEach((item) => {
      const hit = !term || (item.dataset.name || "").includes(term)
      // button_to envolve o botão num <form> — escondemos o form, não o botão.
      const wrapper = item.closest("form") || item
      wrapper.classList.toggle("hidden", !hit)
    })

    // Grupo sem nenhum item visível some junto com seu título.
    this.groupTargets.forEach((group) => {
      const visible = Array.from(group.querySelectorAll("[data-dev-switcher-target='item']"))
        .some((item) => !(item.closest("form") || item).classList.contains("hidden"))
      group.classList.toggle("hidden", !visible)
    })
  }
}
